"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenplanObject = void 0;
var _vendors = require("../../vendors");
var React = _interopRequireWildcard(require("react"));
var _OfferPreviewContainer = require("../../containers/OfferPreviewContainer");
var _hooks = require("../../hooks");
var _OfferTooltipLayout = require("../OfferTooltipLayout");
var styles = _interopRequireWildcard(require("./GenplanObject.css"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ObjectArea = require("../ObjectArea");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const GenplanObject = _ref => {
  let {
    polygonPath,
    center,
    onPolygonClick,
    id,
    onTooltipClick,
    onTooltipPhoneShow,
    isFullscreen,
    objectType,
    uniqName,
    focused
  } = _ref;
  const [opened, setOpened] = React.useState(focused);
  const polygonRef = React.useRef(null);
  const anchorRef = React.useRef(null);
  const tooltipContainerRef = React.useRef(null);
  const insideRefs = React.useMemo(() => [polygonRef, tooltipContainerRef, anchorRef], []);
  const handleOpen = React.useCallback(() => {
    setOpened(true);
    if (onPolygonClick) {
      onPolygonClick(objectType);
    }
  }, [objectType, onPolygonClick]);
  const handleClose = React.useCallback(() => setOpened(false), []);
  (0, _hooks.useOutsideClick)({
    insideRefs,
    onClose: handleClose
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_ObjectArea.ObjectArea, {
    onClick: handleOpen,
    anchorRef: anchorRef,
    polygonRef: polygonRef,
    polygonPath: polygonPath,
    center: center,
    isActive: opened
  }), /*#__PURE__*/React.createElement(_vendors.Popper, {
    open: opened,
    anchorRef: anchorRef,
    placement: "top",
    className: (0, _clsx.default)(styles['popper'], isFullscreen && styles['top'])
  }, /*#__PURE__*/React.createElement(_OfferTooltipLayout.OfferTooltipLayout, {
    ref: tooltipContainerRef,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(_OfferPreviewContainer.OfferPreviewContainer, {
    offerId: id,
    onClick: onTooltipClick,
    onOfferPhoneShow: onTooltipPhoneShow,
    onOfferFetchError: handleClose,
    uniqName: uniqName,
    objectType: objectType
  }))));
};
exports.GenplanObject = GenplanObject;